export const filterReacDataByText = (reacData, textSearch) => {
    return reacData.filter(element => {
        if (!textSearch || textSearch.trim() === '') return true

        const text = textSearch.trim().toLowerCase().split(' ')
        const adapt = d => d != null ? String(d).toLowerCase() : ''
        const rowData = adapt(element.modelo) + adapt(element.capacidad) + adapt(element.procesador)
            + adapt(element.ram) + adapt(element.color) + adapt(element.grado)
            + adapt(element.condicion) + adapt(element.reference)

        return text.every(t => t.length > 0 && rowData.includes(t))
    })
}
